import React, { useState, useEffect } from "react";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
import axios from "axios";
import { Navigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";

const InvoicepaymentCreate = () => {
  const [step, setStep] = useState(1);
  const [client, setClient] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [invoiceid, setInvoiceid] = useState("");
  const [invoiceno, setInvoiceno] = useState("");
  const [paymentdate, setPaymentdate] = useState("");
  const [amount, setAmount] = useState("");
  const [receiptno, setReceiptno] = useState("");
  const [redirect, setRedirect] = useState(false);
  const [clientQuery, setClientQuery] = useState("");
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [invoiceregister, setInvoiceregister] = useState([]);

  // 🔥 Auto-fill today's date + receipt
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setPaymentdate(today);

    const random = Math.random().toString(36).substring(2, 8).toUpperCase();
    setReceiptno(`REC${random}`);
  }, []);

  // 🔍 Search invoices
  const searchInvoices = async () => {
    const { data } = await axios.get(`/invoiceSearch/${client}`);
    setSearchResults(data);
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      if (clientQuery.length >= 3) {
        searchClients();
      }
    }, 400); // debounce

    return () => clearTimeout(delay);
  }, [clientQuery]);

  const searchClients = async () => {
    try {
      const { data } = await axios.get(`clientSearch/${clientQuery}`);
      setClients(data);
      setShowDropdown(true);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSelectClient = async (client) => {
    setSelectedClient(client);
    setClient(client.name);
    setShowDropdown(false);

    // 🔥 fetch invoices using client_id
    const { data } = await axios.get(`invoiceSearch/${client.id}`);
    setInvoiceregister(data);
    setStep(2); // move to invoice selection
  };

  // 📋 Select invoice
  const selectInvoice = (inv) => {
    setInvoiceid(inv.id);
    setInvoiceno(inv.invoice_no);
    setStep(3);
  };

  // 💾 Submit
  const submit = async (e) => {
    e.preventDefault();

    await axios.post("invoicePayment", {
      invoice_no: invoiceno,
      invoice_id: parseInt(invoiceid),
      amount: parseFloat(amount),
      payment_date: paymentdate,
      client_id: selectedClient?.id,
      receipt_no: receiptno,
    });

    setRedirect(true);
  };

  if (redirect) {
    return <Navigate to={"/invoicepayment"} />;
  }

  return (
    <Wrapper pageTitle={"New Invoice Payment"}>
      <InnerNav
        createLink={"/invoicepaymentCreate"}
        listLink={"/invoicepayment"}
      />

      {/* STEP 1: SEARCH */}
      {step === 1 && (
        <div className="p-4 bg-white rounded shadow">
          <h2 className="mb-4 font-bold">Search Invoice</h2>

          <label className="block text-sm relative">
            <span className="text-gray-700">Client</span>

            <input
              className="block w-full p-2 border mt-1"
              placeholder="Search client..."
              value={clientQuery}
              onChange={(e) => setClientQuery(e.target.value)}
              onFocus={() => setShowDropdown(true)}
            />

            {/* 🔽 Dropdown */}
            {showDropdown && clients.length > 0 && (
              <div className="absolute z-10 bg-white border w-full mt-1 max-h-40 overflow-y-auto shadow">
                {clients.map((c) => (
                  <div
                    key={c.id}
                    onClick={() => handleSelectClient(c)}
                    className="p-2 hover:bg-gray-100 cursor-pointer"
                  >
                    {c.name}
                  </div>
                ))}
              </div>
            )}
          </label>

          <div className="mt-4">
            {invoiceregister.map((inv) => (
              <div
                key={inv.id}
                onClick={() => selectInvoice(inv)}
                className="p-3 border mb-2 cursor-pointer hover:bg-gray-100"
              >
                {inv.invoice_no} - {inv.client_name} - {inv.balance}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* STEP 2: PAYMENT */}

      {step === 2 && (
        <table className="w-full whitespace-no-wrap">
          <thead>
            <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
              <th className="px-4 py-3">#Ref </th>
              <th className="px-4 py-3">Invoice date </th>
              <th className="px-4 py-3">Client </th>
              <th className="px-4 py-3">Invoice no </th>
              <th className="px-4 py-3">Invoiced amount </th>
              <th className="px-4 py-3">Amount paid </th>
              <th className="px-4 py-3">Balance amount </th>
              <th className="px-4 py-3">Invoice type </th>
              <th className="px-4 py-3">Action</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
            {invoiceregister?.map((invoice) => {
              return (
                <tr
                  key={invoice.id}
                  className="text-gray-700 dark:text-gray-400"
                >
                  <td className="px-4 py-5">{invoice.id}</td>

                  <td className="px-4 py-3 text-sm">
                    {invoice.invoice_date !== "0001-01-01T00:00:00Z"
                      ? new Date(invoice.invoice_date).toLocaleDateString()
                      : "-"}
                  </td>

                  <td className="px-4 py-3 text-sm">{invoice.client.name}</td>

                  <td className="px-4 py-3 text-sm">{invoice.invoice_no}</td>

                  <td className="px-4 py-3 text-sm">
                    {invoice.invoice_amount}
                  </td>

                  <td className="px-4 py-3 text-sm">{invoice.amount_paid}</td>

                  <td className="px-4 py-3 text-sm">
                    {invoice.balance_amount}
                  </td>

                  <td className="px-4 py-3 text-sm">
                    {invoice.invoice_type || "-"}
                  </td>

                  <td className="flex px-4 py-3 text-sm">
                    <button
                      onClick={() => selectInvoice(invoice)}
                      className="px-3 py-1 bg-blue-500 text-white rounded"
                    >
                      Select
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}

      {/* STEP 2: PAYMENT */}
      {step === 3 && (
        <form onSubmit={submit}>
          <div className="px-4 py-3 bg-white rounded shadow">
            <label className="block mb-2">
              Payment Date
              <input
                type="date"
                value={paymentdate}
                onChange={(e) => setPaymentdate(e.target.value)}
                className="w-full p-2 border"
              />
            </label>

            <label className="block mb-2">
              Invoice No
              <input
                value={invoiceno}
                disabled
                className="w-full p-2 border bg-gray-100"
              />
            </label>

            <label className="block mb-2">
              Amount
              <input
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                className="w-full p-2 border"
              />
            </label>

            <label className="block mb-2">
              Receipt No
              <input
                value={receiptno}
                readOnly
                className="w-full p-2 border bg-gray-100"
              />
            </label>

            <button className="flex items-center bg-blue-600 text-white px-4 py-2 rounded mt-4">
              <FiSave /> <span className="ml-2">Save</span>
            </button>
          </div>
        </form>
      )}
    </Wrapper>
  );
};

export default InvoicepaymentCreate;
